import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getGlobalCookie } from "../../../utils";
import config from "../../../config";

export default function Login() {
	const history = useHistory();

	useEffect(() => {
		if (getGlobalCookie("lessorAccess")) {
			history.push("/assets-listing");
		} else {
			window.location.href = `${config.domain.subDomian}login?apps=camo`;
		}
	}, []);

	return null;
}
